import { useState } from "react";
import { Trans } from "next-i18next/pages";

// mui
import HelpIcon from "@mui/icons-material/Help";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

interface NitoelHelpIconProps1 {
  resource: string;
  helpKey: string;
  message?: string;
}

interface NitoelHelpIconProps2 {
  resource?: string;
  helpKey?: string;
  message: string;
}

// HelpIconの使い方として、以下の二通りの使い方を想定している。
// 1. resourceとhelpKeyを指定して、i18nのキーを指定してヘルプを表示する
// 2. messageを指定して、そのまま表示する
// 用途を限定したほうが良いかと思って、1の手法を用意していたが正直すべて2で良いかなぁと思っている。その内直したい。
type NitoelHelpIconProps = NitoelHelpIconProps1 | NitoelHelpIconProps2;

const NitoelHelpIcon = (props: NitoelHelpIconProps): React.JSX.Element => {
  const { resource, helpKey, message } = props;

  // ヘルプのアイコン用のpopover設定
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  // ヘルプのアイコン用の設定

  return (
    <>
      <IconButton
        size="small"
        sx={{ m: -0.5, mb: -0.2 }}
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        {/* smallだと1.125remで大きかったので直接サイズを指定 */}
        {/* NITOEL_DEV-371の際に色を見直すこと。辻さんいわく、もう少し色が薄いほうが良いとのこと */}
        <HelpIcon color="action" sx={{ fontSize: "0.8rem" }} />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ pointerEvents: "none" }}
      >
        <Typography variant="body2" sx={{ m: 1 }}>
          {/* https://react.i18next.com/latest/trans-component なんか小難しいが、htmlタグを使いたい場合はtではなくTransコンポーネントでやると良い感じにやってくれる(全てのhtmlタグが許可されているわけではないので注意)。改行をしばしば使いたいので切替えた */}
          {/* TODO: i18nを消す */}
          {message ? <div dangerouslySetInnerHTML={{ __html: message }} /> : <Trans i18nKey={`${resource}:help.${helpKey}`} />}
        </Typography>
      </Popover>
    </>
  );
};

export default NitoelHelpIcon;
